import { getUserIdentityForApi } from './auth-aws-sdk';
import { logger } from './logger';

/**
 * 获取API请求的headers，包含Bearer token和用户身份信息
 * @param additionalHeaders 额外的headers对象
 * @returns 包含Authorization和其他必要headers的对象
 */
export const getApiHeaders = (additionalHeaders: Record<string, string> = {}): Record<string, string> => {
  const idToken = localStorage.getItem('cognito_id_token');
  const identity = getUserIdentityForApi();
  
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...additionalHeaders
  };

  // 添加Bearer token
  if (idToken) {
    headers['Authorization'] = `Bearer ${idToken}`;
  } else {
    logger.warn('⚠️ ID token不存在，API请求可能失败');
  }

  // 添加用户身份信息（如果存在）
  if (identity?.sub) {
    headers['X-User-Id'] = identity.sub;
  }
  if (identity?.email) {
    headers['X-User-Email'] = identity.email;
  }

  return headers;
};

/**
 * 获取API请求的headers（不包含Content-Type），用于GET请求等
 * @param additionalHeaders 额外的headers对象
 * @returns 包含Authorization和其他必要headers的对象
 */
export const getApiHeadersWithoutContentType = (additionalHeaders: Record<string, string> = {}): Record<string, string> => {
  const idToken = localStorage.getItem('cognito_id_token');
  const identity = getUserIdentityForApi();
  
  const headers: Record<string, string> = {
    ...additionalHeaders
  };

  // 添加Bearer token
  if (idToken) {
    headers['Authorization'] = `Bearer ${idToken}`;
  } else {
    logger.warn('⚠️ ID token不存在，API请求可能失败');
  }

  // 添加用户身份信息（如果存在）
  if (identity?.sub) {
    headers['X-User-Id'] = identity.sub;
  }
  if (identity?.email) {
    headers['X-User-Email'] = identity.email;
  }

  return headers;
};
